const TOUCH = !!navigator.userAgent.match(
  /Android|webOS|iPad|iPod|BlackBerry|Windows Phone/i,
);

export default {
  getCursorPosition: event => {
    if (event.touches && event.touches[0]) {
      return {
        cx: event.touches[0].clientX,
        cy: event.touches[0].clientY,
        px: event.touches[0].pageX,
        py: event.touches[0].pageY,
      };
    } else if (event.changedTouches && event.changedTouches[0]) {
      return {
        cx: event.changedTouches[0].clientX,
        cy: event.changedTouches[0].clientY,
        px: event.changedTouches[0].pageX,
        py: event.changedTouches[0].pageY,
      };
    } else {
      return {
        cx: event.clientX,
        cy: event.clientY,
        px: event.pageX,
        py: event.pageY,
      };
    }
  },
  guid: () => {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  },
  events: {
    mousedown: TOUCH ? 'touchstart' : 'mousedown',
    mousemove: TOUCH ? 'touchmove' : 'mousemove',
    mouseup: TOUCH ? 'touchend' : 'mouseup',
    mouseover: TOUCH ? 'xxx' : 'mouseover',
    mouseout: TOUCH ? 'xxx' : 'mouseout',
    mouseenter: TOUCH ? 'mouseenter' : 'mouseenter',
    mouseleave: TOUCH ? 'touchcancel' : 'mouseleave',
    touch: TOUCH,
  },
  preloadImages: imgs => {
    imgs = Array.isArray(imgs) ? imgs : [imgs];
    imgs.forEach(img => {
      const imgObj = new Image();

      imgObj.src = img;
    });
  },
  waitForImage: img => {
    return new Promise(function(resolve) {
      const imgObj = new Image();
      imgObj.onload = resolve;

      imgObj.src = img;
    });
  },
  snapToBounds: (x, y, width, height) => {
    let rightBounds = { x, y };

    if (x < 0) rightBounds.x = 0;
    if (y < 0) rightBounds.y = 0;

    if (x + width > 1) rightBounds.x = 1 - width;
    if (y + height > 1) rightBounds.y = 1 - height;

    return rightBounds;
  },
  multilineTextToArray(txt) {
    return txt.split(/(?:\r\n|\r|\n)/g);
  },
};
